import { Lottie } from "lottie-react";
import React from "react";

import loadingAnimation from "../assets/loading.json";

const wrapStyles = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "40px 0",
  width: "100%",
};

// Same animation the customer app plays, so the brand loader matches across
// the apps (foodoor-userApp-RN/src/assets/animation/loading.json).
function Spinner({ size = 96, fullScreen = false }) {
  return (
    <div
      style={
        fullScreen
          ? { ...wrapStyles, minHeight: "60vh", padding: 0 }
          : wrapStyles
      }
      role="status"
      aria-label="Loading"
    >
      <Lottie
        src={loadingAnimation}
        autoplay
        loop
        style={{ width: size, height: size }}
      />
    </div>
  );
}

export default Spinner;
